@if (useMobileLayout$ | async) {
  <red-tabs-layout></red-tabs-layout>
} @else {
  <red-web-layout></red-web-layout>
}
